var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "pr-2 pl-3", attrs: { column: "", id: "mask-toolbar" } },
    [
      _c("v-flex", { staticClass: "mb-2 body-2", attrs: { xs12: "" } }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$tc("Mask", 1)) +
            " " +
            _vm._s(_vm.selectedMask ? _vm.selectedMask.mk_label : "") +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "mb-3" },
        [
          _c("div", { staticClass: "toolbar-section-title" }, [
            _vm._v(_vm._s(_vm.$tc("DuctEntry", 2)))
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { small: "", block: "", disabled: _vm.disabled },
              on: { click: _vm.openDuctSelector }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("Create")) + "...")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { small: "", block: "", disabled: _vm.disabled },
              on: { click: _vm.renameDuctEntries }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("label")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("Relabel")))])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c("div", { staticClass: "toolbar-section-title" }, [
            _vm._v(_vm._s(_vm.$tc("Mask", 1)))
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { small: "", block: "", disabled: _vm.disabled },
              on: { click: _vm.openMirrorSection }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("content_copy")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("MirrorTo")) + "...")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { small: "", block: "", disabled: _vm.disabled },
              on: { click: _vm.openResizeSection }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v("photo_size_select_small")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("Resize")) + "...")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2430e2d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2430e2d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskToolbar.vue
// module id = null
// module chunks = 